import React from 'react'
import { Helmet } from 'react-helmet'
import utils from '../utils'
import { FaHeart } from 'react-icons/fa'
import { Link } from 'react-router-dom'

function PageNotFound(props) {
    const url = window.location.href
    return (
        <div>
            <Helmet>
                <title>Page Not Found - {utils.siteName}</title>
                <link rel="canonical" href={url} />
                <meta
                    property="description"
                    content="" />
            </Helmet>
            <main className="flex-grow flex flex-col items-center justify-center px-6 py-12">
                <div className="max-w-[600px] w-full text-center">
                    <div className="mb-8 flex justify-center">
                        <svg
                            className="text-primary"
                            fill="none"
                            height="160"
                            viewBox="0 0 320 160"
                            width="320"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                className="opacity-20"
                                d="M40 80H80V120M80 40V120"
                                stroke="currentColor"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="8"
                            ></path>
                            <path
                                d="M120 80H135L145 40L160 120L175 60L185 80H200"
                                stroke="currentColor"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="8"
                            ></path>
                            <path
                                className="opacity-20"
                                d="M240 80H280V120M280 40V120"
                                stroke="currentColor"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="8"
                            ></path>
                            <g transform="translate(140, 75) rotate(-15)">
                                <rect
                                    fill="#fbbf24"
                                    fillOpacity="0.9"
                                    height="16"
                                    rx="4"
                                    width="40"
                                    x="0"
                                    y="0"
                                ></rect>
                                <rect
                                    fill="#fcd34d"
                                    height="12"
                                    rx="1"
                                    width="16"
                                    x="12"
                                    y="2"
                                ></rect>
                                <circle cx="6" cy="8" fill="white" fillOpacity="0.5" r="1"></circle>
                                <circle cx="34" cy="8" fill="white" fillOpacity="0.5" r="1"></circle>
                            </g>
                        </svg>
                    </div>
                    <div className="space-y-6">
                        <div>
                            <h1 className="text-primary text-6xl md:text-8xl font-black font-display mb-2 tracking-tighter">
                                404
                            </h1>
                            <h2 className="text-slate-900 dark:text-white text-2xl md:text-3xl font-bold font-display">
                                We can't find the page you are looking for.
                            </h2>
                        </div>
                        <p className="text-slate-500 dark:text-slate-400 text-lg max-w-md mx-auto leading-relaxed">
                            It looks like this link is out of commission. Don't worry, our team is already on the case to patch things up.
                        </p>
                        <div className="pt-4">
                            <Link
                                to={'/'} 
                                className="inline-flex items-center justify-center bg-primary text-white px-10 py-4 rounded-full text-lg font-bold shadow-lg shadow-sky-200 dark:shadow-none hover:scale-105 transition-transform active:scale-95 group">
                                <span className="material-symbols-outlined mr-2 group-hover:animate-pulse">
                                    <FaHeart/>
                                </span>
                                Go Home
                            </Link>
                        </div>
                    </div>
                </div>
            </main>

        </div>
    )
}

export default PageNotFound